import React from 'react';
import './BeeLoader.css';

const BeeSVG = () => (
  <svg width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="32" cy="32" rx="16" ry="14" fill="#FFB800" />
    <path d="M32 18h-6c-6 0-10 4-12 8h36c-2-4-6-8-12-8h-6z" fill="#FFB800" />
    <path d="M32 46h-6c-6 0-10-4-12-8h36c-2 4-6 8-12 8h-6z" fill="#FFB800" />
    <path
      d="M20 28h24M20 32h24M20 36h24"
      stroke="#000"
      strokeWidth="2"
      strokeLinecap="round"
      opacity="0.3"
    />
    <path
      d="M20 24c-8-4-12 0-12 8"
      stroke="#FFF"
      strokeWidth="4"
      strokeLinecap="round"
      opacity="0.7"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        values="-10 20 24; 10 20 24; -10 20 24"
        dur="0.2s"
        repeatCount="indefinite"
      />
    </path>
    <path
      d="M44 24c8-4 12 0 12 8"
      stroke="#FFF"
      strokeWidth="4"
      strokeLinecap="round"
      opacity="0.7"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        values="10 44 24; -10 44 24; 10 44 24"
        dur="0.2s"
        repeatCount="indefinite"
      />
    </path>
    <circle cx="32" cy="22" r="6" fill="#704E00" />
    <path d="M29 18c-2-4-6-4-8-2" stroke="#704E00" strokeWidth="1.5" />
    <path d="M35 18c2-4 6-4 8-2" stroke="#704E00" strokeWidth="1.5" />
    <path d="M32 46l0 4" stroke="#704E00" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const BeeLoader = () => (
  <div className="flex flex-col items-center justify-center p-8">
    <div className="relative w-32 h-32">
      {/* Honeycomb background pattern */}
      <div className="absolute inset-0 opacity-[0.06]">
        <svg width="100%" height="100%" viewBox="0 0 128 128">
          <pattern id="honeycomb" width="20" height="17.32" patternUnits="userSpaceOnUse">
            <polygon
              points="10,0 20,5 20,12.32 10,17.32 0,12.32 0,5"
              fill="none"
              stroke="#FFB700"
              strokeWidth="1"
            />
          </pattern>
          <rect width="100%" height="100%" fill="url(#honeycomb)" />
        </svg>
      </div>

      {/* Guide circle */}
      <div className="absolute inset-0 border border-honey-200/20 dark:border-honey-700/20 rounded-full" />

      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="absolute left-1/2 top-1/2 -ml-2.5 -mt-2.5 filter drop-shadow-md"
          style={{
            animation: `loadingPath 1.5s linear infinite`,
            animationDelay: `${i * -0.5}s`,
          }}
        >
          <BeeSVG />
        </div>
      ))}
    </div>
    <p className="mt-6 text-honey-700/50 dark:text-honey-400/50 text-xs font-light tracking-widest uppercase animate-pulse">
      Buzzing...
    </p>
  </div>
);

export default BeeLoader;
